import { render, staticRenderFns } from "./leftmunu.vue?vue&type=template&id=07c99196&scoped=true"
import script from "./leftmunu.vue?vue&type=script&lang=js"
export * from "./leftmunu.vue?vue&type=script&lang=js"
import style0 from "./leftmunu.vue?vue&type=style&index=0&id=07c99196&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c99196",
  null
  
)

export default component.exports